import { RequireChildrenFor } from "@omni/types/components/utils/children.types";
import { cn } from "@omni/utils/styles";

export type StepBaseProps = {
    className?: string;
};

const Base = ({ children, className }: RequireChildrenFor<StepBaseProps>) => {
    return (
        <div className={cn("tw:h-full tw:w-full", className)}>{children}</div>
    );
};

export { Base };
